@if (data(); as data) {
  <div class="flex flex-col gap-6">
    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Zamówienie #{{ data.number }}</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Status zamówiania">
            <app-order-status [status]="data.status" />
          </app-details-view>

          <app-details-view label="Właściciel">
            @if (data.owner; as owner) {
              @if (owner.hasDisplayDetails) {
                <div class="flex flex-col">
                  <div>{{ owner.primaryLabel }}</div>

                  @if (owner.secondaryLabel; as secondaryLabel) {
                    <div class="text-sm text-gray-500">
                      {{ secondaryLabel }}
                    </div>
                  }
                </div>
              } @else {
                <span class="font-mono text-sm break-all">{{ owner.id }}</span>
              }
            } @else {
              Gość
            }
          </app-details-view>

          <app-details-view label="Data zamówienia">
            <app-date [date]="data.createdAt" />
          </app-details-view>

          <app-details-view label="Data opłacenia">
            @if (data.paidAt; as paidAt) {
              <app-date [date]="paidAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Data anulowania">
            @if (data.cancelledAt; as cancelledAt) {
              <app-date [date]="cancelledAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Data zrealizowania">
            @if (data.completedAt; as completedAt) {
              <app-date [date]="completedAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Data zwrotu">
            @if (data.refundedAt; as refundedAt) {
              <app-date [date]="refundedAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Łączna kwota">
            @if (isNil(data.refundSummary)) {
              <app-currency [amount]="data.totalPrice" />
            } @else {
              <app-refunded-price
                [currentPrice]="data.refundSummary.currentPrice"
                [refundedPrice]="data.refundSummary.refundedPrice"
                [originalPrice]="data.refundSummary.originalPrice" />
            }
          </app-details-view>

          @if (isNotNil(data.temporaryInvoice)) {
            <app-details-view label="Proforma">
              @if (data.temporaryInvoice.canBeDownloaded) {
                <div
                  class="text-[#3858E9] underline decoration-dotted"
                  role="button"
                  (click)="
                    handleDownloadInvoiceClick(data.temporaryInvoice.id)
                  ">
                  {{ data.temporaryInvoice.number }}
                </div>
              } @else {
                {{ data.temporaryInvoice.number }}
              }
            </app-details-view>
          }

          @if (isNotNil(data.invoice)) {
            <app-details-view label="Faktura">
              @if (data.invoice.canBeDownloaded) {
                <div
                  class="text-[#3858E9] underline decoration-dotted"
                  role="button"
                  (click)="handleDownloadInvoiceClick(data.invoice.id)">
                  {{ data.invoice.number }}
                </div>
              } @else {
                {{ data.invoice.number }}
              }
            </app-details-view>
          }
        </div>

        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <div class="lg:col-span-2 xl:col-span-3">
            <app-details-view label="Komentarz użytkownika">
              @if (isNotNil(data.comment) && !isEmptyString(data.comment)) {
                <div class="whitespace-pre-line">
                  {{ data.comment }}
                </div>
              } @else {
                <app-no-data />
              }
            </app-details-view>
          </div>
        </div>

        @if (true) {
          <p-divider
            appPrimengDivider
            class="mx-auto w-4/5" />
        }

        <div class="flex items-center justify-end gap-2">
          @if (data?.canBeCancelled) {
            <p-button
              (onClick)="handleCancelClick()"
              appPrimengButton
              size="small"
              label="Anuluj"
              severity="danger" />
          }

          @if (data?.canBeMarkAsPaid) {
            <p-button
              (onClick)="handleMarkAsPaidClick()"
              appPrimengButton
              size="small"
              label="Oznacz jako opłacone"
              severity="warn" />
          }

          @if (data?.canBeRefunded) {
            <p-button
              (onClick)="handlePartialRefundClick()"
              appPrimengButton
              size="small"
              label="Częściowy zwrot"
              severity="contrast" />

            <p-button
              (onClick)="handleFullRefundClick()"
              appPrimengButton
              size="small"
              label="Pełny zwrot"
              severity="info" />
          }

          @if (data?.canBeCompleted) {
            <p-button
              (onClick)="handleCompleteClick()"
              appPrimengButton
              size="small"
              label="Oznacz jako zrealizowane"
              severity="success" />
          }
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Szczegóły zamówienia</h5>

      <p-divider appPrimengDivider />

      <div class="flex flex-col gap-3">
        <app-details-view label="Zamówione produkty">
          <div class="flex flex-col gap-3">
            @for (
              item of data.items;
              track 'product' + index;
              let index = $index;
              let count = $count
            ) {
              <app-admin-order-item-card
                [count]="count"
                [index]="index"
                [item]="item" />
            } @empty {
              <app-no-data />
            }
          </div>
        </app-details-view>

        <div class="flex flex-col gap-3 bg-gray-50 px-6 py-3">
          @for (
            shipment of data.shipments;
            track 'shipment-price' + index;
            let index = $index
          ) {
            <div
              class="grid grid-cols-1 items-center justify-between gap-3 bg-gray-50 xl:grid-cols-3">
              <div class="font-bold">
                {{ shipment.methodName }}
              </div>

              <div class="flex gap-1">
                <span>Status:</span>
                <div class="font-bold">
                  <app-shipment-status [status]="shipment.status" />
                </div>
              </div>

              <div class="ms-auto font-bold">
                @if (isNil(shipment.refundSummary)) {
                  <app-currency [amount]="shipment.price" />
                } @else {
                  <app-refunded-price
                    [refundedPrice]="shipment.refundSummary.refundedPrice"
                    [originalPrice]="shipment.refundSummary.originalPrice"
                    [currentPrice]="shipment.refundSummary.currentPrice" />
                }
              </div>
            </div>
          } @empty {
            <app-no-data />
          }

          <p-divider appPrimengDivider />

          <div class="flex items-center gap-3">
            <div class="font-bold">Łącznie</div>

            <div class="ms-auto flex items-center font-bold">
              @if (isNil(data.refundSummary)) {
                <app-currency [amount]="data.totalPrice" />
              } @else {
                <app-refunded-price
                  [currentPrice]="data.refundSummary.currentPrice"
                  [refundedPrice]="data.refundSummary.refundedPrice"
                  [originalPrice]="data.refundSummary.originalPrice" />
              }
            </div>
          </div>
        </div>

        <app-details-view label="Metoda płatności">
          <div class="flex flex-col gap-3">
            @for (payment of data.payments; track payment) {
              <div
                class="grid grid-cols-1 items-center justify-between gap-3 bg-gray-50 p-6 xl:grid-cols-3">
                <div class="flex gap-1">
                  <span class="font-bold">{{ payment.paymentMethodName }}</span>
                </div>

                <div class="flex gap-1">
                  <span>Status:</span>
                  <div class="font-bold">
                    <app-payment-status [status]="payment.status" />
                  </div>
                </div>

                <div class="ms-auto flex items-center gap-1">
                  <span>Nr płatności: </span>
                  <span class="font-bold">{{ payment.number }}</span>
                </div>
              </div>
            } @empty {
              <app-no-data />
            }
          </div>
        </app-details-view>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Adres rozliczeniowy</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Imie i nazwisko">
            <div class="flex gap-1">
              <span>{{ data.billingAddress.firstName }}</span>
              <span>{{ data.billingAddress.lastName }}</span>
            </div>
          </app-details-view>

          <app-details-view label="Adres e-mail">
            {{ data.billingAddress.email }}
          </app-details-view>

          <app-details-view label="Numer telefonu">
            {{ data.billingAddress.phone.numberWithPrefix }}
          </app-details-view>

          <app-details-view label="Adres">
            {{ data.billingAddress.asString }}
          </app-details-view>

          <app-details-view label="Nazwa firmy">
            @if (isNotNil(data.billingAddress.companyName)) {
              {{ data.billingAddress.companyName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="NIP firmy">
            @if (isNotNil(data.billingAddress.companyNip)) {
              {{ data.billingAddress.companyNip }}
            } @else {
              <app-no-data />
            }
          </app-details-view>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>
        <div class="flex items-center gap-3">
          <div>Lista przesyłek</div>
          <div class="ms-auto">
            <p-button
              (onClick)="handleAddShippingClick()"
              appPrimengButton
              size="small"
              variant="outlined"
              label="Dodaj przesyłkę" />
          </div>
        </div>
      </h5>

      <p-divider appPrimengDivider />

      <div class="flex flex-col gap-3">
        @for (
          shipment of data.shipments;
          track 'shipment' + index;
          let index = $index;
          let count = $count
        ) {
          <div
            class="relative flex flex-col gap-1 p-6"
            [class.border]="shipment.isDeleted"
            [class.border-dashed]="shipment.isDeleted"
            [class.border-gray-300]="shipment.isDeleted"
            [class.bg-gray-50]="!shipment.isDeleted"
            [class.bg-gray-100]="shipment.isDeleted"
            [class.opacity-60]="shipment.isDeleted">
            @if (count > 1) {
              <div
                class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                {{ index + 1 }}.
              </div>
            }

            <div>
              <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
                <app-details-view label="Imie i nazwisko">
                  <div class="flex gap-1">
                    <span>{{ shipment.address.firstName }}</span>
                    <span>{{ shipment.address.lastName }}</span>
                  </div>
                </app-details-view>

                <app-details-view label="Adres e-mail">
                  {{ shipment.address.email }}
                </app-details-view>

                <app-details-view label="Numer telefonu">
                  {{ shipment.address.phone.numberWithPrefix }}
                </app-details-view>

                <app-details-view label="Adres">
                  {{ shipment.address.asString }}
                </app-details-view>

                <app-details-view label="Nazwa firmy">
                  @if (isNotNil(shipment.address.companyName)) {
                    {{ shipment.address.companyName }}
                  } @else {
                    <app-no-data />
                  }
                </app-details-view>
              </div>
            </div>

            <p-divider
              appPrimengDivider
              class="mx-auto w-4/5" />

            <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
              <app-details-view label="Sposób dostawy">
                {{ shipment.methodName }}
              </app-details-view>

              @if (isNotNil(shipment.address.shippingPointName)) {
                <div class="col-span-2">
                  <app-details-view label="Punkt dostawy">
                    {{ shipment.address.shippingPointName }}
                  </app-details-view>
                </div>
              }

              <app-details-view label="Status">
                <app-shipment-status [status]="shipment.status" />
              </app-details-view>

              @if (isNotNil(shipment.scheduledShippingDate)) {
                <app-details-view label="Planowana data wysyłki">
                  <app-date [date]="shipment.scheduledShippingDate" />
                </app-details-view>
              }

              <app-details-view label="Data dodania">
                <app-date-time [date]="shipment.createdAt" />
              </app-details-view>

              <app-details-view label="Wielkość przesyłki">
                <app-admin-shipment-size-type [size]="shipment.packageSize" />
              </app-details-view>

              <app-details-view label="Komentarz">
                @if (isNotNil(shipment.comment)) {
                  {{ shipment.comment }}
                } @else {
                  <app-no-data />
                }
              </app-details-view>

              @if (isNotNil(shipment.trackingUrl)) {
                <div class="lg:col-span-2 xl:col-span-3">
                  <app-details-view label="Adres do śledzenia przesyłki">
                    <app-external-link
                      [link]="shipment.trackingUrl"
                      [underline]="false">
                      <div class="text-[#3858E9] underline decoration-dotted">
                        {{ shipment.trackingUrl }}
                      </div>
                    </app-external-link>
                  </app-details-view>
                </div>
              }
            </div>

            @if (shipment.componentGroups.length) {
              <p-divider
                appPrimengDivider
                class="mx-auto w-4/5" />

              <app-admin-order-shipment-component-groups
                [groups]="shipment.componentGroups" />
            }

            @if (
              shipment.canBeDeleted ||
              shipment.canBeSent ||
              shipment.isSent ||
              shipment.canBeEdited
            ) {
              <p-divider
                appPrimengDivider
                class="mx-auto w-4/5" />
            }

            <div class="flex items-center justify-end gap-2">
              @if (shipment.isSent) {
                <div class="flex justify-end">
                  <p-button
                    appPrimengButton
                    size="small"
                    label="Pobierz etykietę"
                    (onClick)="downloadLabelClick(shipment.id)" />
                </div>
              }

              @if (shipment.canBeDeleted) {
                <p-button
                  (onClick)="handleRemoveButtonClick(shipment.id)"
                  appPrimengButton
                  size="small"
                  label="Usuń"
                  severity="danger" />
              }

              @if (shipment.canBeEdited) {
                <p-button
                  (onClick)="handleShippingAddressUpdateClick(shipment.id)"
                  appPrimengButton
                  size="small"
                  label="Edytuj"
                  severity="info" />
              }

              @if (shipment.canBeSent) {
                <p-button
                  (onClick)="handleGenerateAndSendButtonClick(shipment.id)"
                  appPrimengButton
                  size="small"
                  severity="success"
                  label="Generuj i wyślij" />
              }
            </div>
          </div>
        } @empty {
          <app-no-data />
        }
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>
        <div class="flex items-center gap-3">
          <div>Lista zwrotów</div>
        </div>
      </h5>

      <p-divider appPrimengDivider />

      <app-admin-order-refund-list
        [refunds]="valueOrDefault(data.refunds, [])" />
    </div>
  </div>
} @else {
  <app-spinner-filled />
}

<p-dialog
  [customCloseEvent]="additionalShippingDialogCustomCloseEvent"
  [visible]="additionalShippingDialogVisibility()"
  appPrimengDialog
  appPrimengDialogCustomCloseEvent
  header="Dodawanie przesyłki">
  @if (additionalShippingDialogVisibility()) {
    <app-admin-additional-shipping
      (cancelEvent)="handleAdditionalShippingCancelEvent()"
      (submitEvent)="handleAdditionalShippingSubmitEvent()"
      [orderId]="id()" />
  }
</p-dialog>

<p-drawer
  [customCloseEvent]="customCloseShippingAddressEditEvent"
  [visible]="shippingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Edycja adresu przesyłki zamówienia</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (shipmentId(); as shipmentId) {
        <app-admin-order-shipping-address-edit
          (submitEvent)="handleSubmitShippingAddressEditEvent()"
          [orderId]="id()"
          [shipmentId]="shipmentId" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customClosePartialRefundDrawerEvent"
  [visible]="partialRefundDrawerVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Częściowy zwrot zamówienia</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (partialRefundDrawerVisibility()) {
        <app-admin-order-partial-refund-form
          (cancelEvent)="handlePartialRefundCancelEvent()"
          (submitEvent)="handlePartialRefundSubmitEvent()"
          [id]="id()" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>
